import { css } from '@emotion/react';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { FinanceOption } from '../../../../types/care-credit.types';

export type FinanceOptionDetailsProps = {
  financeOption: FinanceOption;
};

export const styles = {
  root: css`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: ${theme.spacing(2)};
  `,
  totals: css`
    display: flex;
    width: 100%;
    background: ${theme.colors.neutral5};
    padding: ${theme.spacing(2)};
    gap: ${theme.spacing(1)};

    & > div {
      width: 33.33%;
      flex-shrink: 0;
    }

    @media (max-width: ${breakpoints.small.min}px) {
      flex-wrap: wrap;
      & > div {
        width: 100%;
      }
    }
  `,
};
